export default {
	emails: {
		isSending: null
	},
	messages: {
		error: null,
		success: null
	},
	language: {
		currentLang: { value: 'bg', label: 'BG' }
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/initialState.js